import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../util/config';

/**
 * Component that tracks page views when the URL changes
 * This solves the issue of Google Analytics not tracking page views in SPAs
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if the window object exists and if gtag function is defined
    if (typeof window !== 'undefined' && window.gtag && typeof window.gtag === 'function') {
      const pagePath = location.pathname + location.search;
      
      try {
        // Send pageview event to Google Analytics
        window.gtag('config', config.GA_TRACKING_ID, {
          page_path: pagePath,
        });
        
        // Also track as an event for more detailed analytics
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: pagePath,
        });
        
        console.log(`Page view tracked: ${pagePath}`);
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    } else {
      console.warn('Google Analytics tracking is not available - gtag function not found on window object');
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default PageTracker;